var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('retailer-logos-grid-section',{staticClass:"retailer-logos-grid-section-module",attrs:{"retailers":_vm.retailers}})}
var staticRenderFns = []

export { render, staticRenderFns }